import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`For an exhustive list of cloud related definitions refer to this guide: `}<a parentName="p" {...{
        "href": "https://github.com/cncf/glossary/tree/main/definitions"
      }}>{`https://github.com/cncf/glossary/tree/main/definitions`}</a></p>
    <h2>{`Hybrid-cloud`}</h2>
    <ul>
      <li parentName="ul">{`Ability and flexibility of running parts or all of your cloud solution and services on premise and / or on a public cloud`}</li>
      <li parentName="ul">{`Flexible deployment of cloud services into various topologies (public / public, public / private, private / private and so on)`}</li>
      <li parentName="ul">{`Choice in deployment and management of cloud services`}</li>
    </ul>
    <blockquote>
      <p parentName="blockquote">{`An open hybrid cloud combines and unifies public cloud and private cloud services from multiple cloud vendors to create a single, flexible IT infrastructure, based on open source technologies. Learn more about `}<a parentName="p" {...{
          "href": "https://www.ibm.com/cloud/learn/hybrid-cloud"
        }}>{`What is Hybrid Cloud?`}</a>{`.`}</p>
    </blockquote>
    <h2>{`Multi-cloud`}</h2>
    <ul>
      <li parentName="ul">{`Running parts or all of a cloud solutions in multiple clouds.`}</li>
      <li parentName="ul">{`Ability and flexibility to move certain parts of a cloud solution to different cloud providers.`}</li>
      <li parentName="ul">{`The opposite of mono-cloud.`}</li>
    </ul>
    <blockquote>
      <p parentName="blockquote"><a parentName="p" {...{
          "href": "https://developer.ibm.com/videos/mutlicloud-for-developers-an-introduction/"
        }}>{`https://developer.ibm.com/videos/mutlicloud-for-developers-an-introduction/`}</a></p>
    </blockquote>
    <h2>{`Lock-in and lock-down`}</h2>
    <ul>
      <li parentName="ul">{`A condition in which continuing to use the cloud software or services requires you to select one specific cloud provider`}</li>
      <li parentName="ul">{`Cloud software that can be used with specific cloud or cloud services`}</li>
      <li parentName="ul">{`The opposite of open`}</li>
    </ul>
    <h2>{`Open Source Software`}</h2>
    <ul>
      <li parentName="ul">{`Planning and building of software in the open with resulting artifacts available to all`}</li>
      <li parentName="ul">{`Open governance to allow all to participate in all aspects of the development and planning`}</li>
      <li parentName="ul">{`Using a license that allows software to be used, modified, embedded and sold by anyone`}</li>
    </ul>
    <h2>{`Inner-Source Software`}</h2>
    <ul>
      <li parentName="ul">{`Building software with intention of OSS`}</li>
      <li parentName="ul">{`Keeping governance and planning in house`}</li>
      <li parentName="ul">{`Releases done in the open`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      